// extracted by mini-css-extract-plugin
module.exports = {"centerButton":"_2LR2Om","buttonFormWrapper":"_3tJ38a"};